"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanInputExperiment = exports.getAnonymousCall = void 0;
var authorize_1 = require("../authorize");
var index_1 = require("./bff/index");
var module_util_1 = require("../../utils/module.util");
var pricingApi = (0, module_util_1.getModules)({
    getPricing: {
        bffFn: index_1.getPricing_bff
    },
    getPricingV2: {
        bffFn: index_1.getPricingV2_bff
    },
    getPricingByExternalId: {
        bffFn: index_1.getPricingByExternalId_bff
    }
});
/* istanbul ignore next */
function getAnonymousCall() {
    return (!!(authorize_1.authorizeParams === null || authorize_1.authorizeParams === void 0 ? void 0 : authorize_1.authorizeParams.noCookie) &&
        !(authorize_1.authorizeParams === null || authorize_1.authorizeParams === void 0 ? void 0 : authorize_1.authorizeParams.idToken) &&
        !(authorize_1.authorizeParams === null || authorize_1.authorizeParams === void 0 ? void 0 : authorize_1.authorizeParams.accessToken));
}
exports.getAnonymousCall = getAnonymousCall;
// Changes exp cookie delimiter from | to , for jericho services
function cleanInputExperiment(pricingInput) {
    var _a;
    /* istanbul ignore next */
    pricingInput.experiment = ((_a = pricingInput.experiment) === null || _a === void 0 ? void 0 : _a.replace("|", ",")) || "";
    return pricingInput;
}
exports.cleanInputExperiment = cleanInputExperiment;
exports.default = pricingApi;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/pricing-sdk/dist/lib-esm/modules/pricingApi/index.js
// module id = 830
// module chunks = 11